<template lang="">
  <div class="flex-fill">
    <section id="banner" class="" style="background-image: url('static/img/default/hero.svg'); background-size: cover; background-repeat: no-repeat; background-position: top center; ">
      <div class="container py-20">
        <div class="text-left max-w-lg-600px my-20">
          <span style="font-size:3.5rem" class="d-block text-white font-weight-bolder mb-10">Bagikan Keluhan Anda secara Anonim di Layanan Pengaduan SEKAR Hutama Karya</span>
          <button v-b-modal.aduan-modal class="btn btn-lg btn-success font-size-h3 font-weight-bolder px-15">Kirim Aduan</button>
          <div class="mt-7 pointer">
            <a :href="wbsURL" target="_blank" class="text-white font-size-h5 text-underline">
              Login Admin Aduan
            </a>
            <i class="ri-arrow-right-circle-line text-white pl-3"></i>
          </div>
        </div>
      </div>
    </section>
    <section id="contents-first">
      <div class="container py-20">
        <div class="text-center">
          <span style="font-size:2.5rem" class="d-block text-dark-75 font-weight-bolder">
            Aduan Anda akan terkirim secara
            <br />
            Anonymous dan Terenkripsi
          </span>
          <p class="mt-3 text-dark-75 font-size-h5 mb-15">
            Memastikan keamanan dan kenyamanan bagi Anda yang ingin berbagi masalah
            <br />
            atau keluhan tanpa khawatir mengenai pengungkapan identitas pribadi
          </p>
          <div class="row flex-wrap align-items-center justify-content-center">
            <div class="col-12 col-lg-4" v-for="(ic, index) in icons" :key="index + '-icons'">
              <div class="card card-custom card-up rounded-xl">
                <div class="card-body py-15">
                  <img :src="ic.icon" alt="" class="max-w-100px mb-10" />
                  <span v-html="ic.capt" style="font-size:2rem;word-break: break-word" class="d-block text-dark-75 font-weight-boldest">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="contents">
      <div class="container py-20">
        <div class="text-center">
          <span style="font-size:2.5rem" class="d-block text-dark-75 font-weight-bolder mb-10">Anda Bisa Menyampaikan Aduan Tentang </span>
          <div class="d-flex flex-wrap align-items-center justify-content-center">
            <div v-for="(x, index) in category" :key="index + '-category'" style="font-size:1.8rem;background-color: #edf6fc" class="text-primary font-weight-bold px-10 py-5 m-3 nowrap rounded-xl">{{ x.name }}</div>
          </div>
        </div>
      </div>
    </section>
    <b-modal :id="'aduan-modal'" hide-footer hide-header centered size="xl">
      <h4 class="text-secondary font-weight-bolder mb-5">Tambah Aduan</h4>
      <div class=" gutter-b">
        <div class="d-flex align-items-center mb-2">
          <label class="mb-0 font-weight-bolder" for="">Alamat Email</label>
          <span class="label label-light-danger label-pill label-inline label-sm ml-2">wajib</span>
        </div>
        <div class="form-group d-flex align-items-center mb-0">
          <input :disabled="isOTPsend" v-model="email" type="email" placeholder="ketikkan alamat email anda disini ..." class="form-control fc-custom mock-disabled" />
          <div class="nowrap ml-3">
            <button :disabled="isOTPsend || !email || isLoadingOtp" @click="requestOTP()" class="btn btn-success font-size-sm font-weight-bold">
              Kirim OTP
              <b-spinner v-if="isLoadingOtp" small class="ml-3"></b-spinner>
            </button>
          </div>
        </div>
      </div>
      <div v-if="!isOTPsend" class="alert alert-custom px-4 py-2" style="background-color: #f3f6f9;" role="alert">
        <div class="alert-icon alert-icon-top">
          <i class="ri-notification-fill text-secondary"></i>
        </div>
        <div class="alert-text">
          <p class="mb-0">
            Pastikan untuk menggunakan Email Cadangan (Email Anonymous) anda. Karena email ini akan digunakan untuk mengirim proses tindaklanjut
          </p>
        </div>
      </div>
      <div v-else class="d-flex">
        <div id="inputs" class="border-right pr-5">
          <v-otp-input ref="otpInput" input-classes="otp-input" separator="" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-complete="otpComplete" />
          <div class="mt-2 gutter-b">
            <span class="text font-size-sm">
              Tidak menerima email?
              <span v-if="!resendWaiting" @click="requestOTP(true)" class="text-secondary text-hover-primary pointer pl-2 font-weight-bold">Kirim Ulang</span>
              <span v-else class="text-dark pl-2 font-weight-bold">00:{{ resendWaiting }} Kirim Ulang</span>
              <b-spinner v-if="resendLoading" small class="ml-3"></b-spinner>
            </span>
          </div>
          <button @click="checkOTP()" :disabled="!otpData" class="btn btn-primary btn-lg font-size-md font-weight-bold pl-10">
            Isi Form Aduan
            <i class="ri-arrow-right-s-line"></i>
          </button>
        </div>
        <div class="text-left max-w-250px ml-7">
          <span class="d-block font-size-lg font-weight-bold nowrap">Periksa Pesan Masuk Email Anda</span>
          <span class="d-block font-weight-boldX mt-2 mb-4">
            Kami telah mengirim Kode
            <b>OTP</b>
            ke Email Anda
          </span>
          <span class="d-block font-size-sm text-muted">Bantuan : Periksa folder spam Anda jika email tidak masuk ke Kotak Pesan utama</span>
          <span @click="isOTPsend = !isOTPsend" class="d-block font-size-sm text-info mt-4 pointer font-weight-bold">Ubah Alamat Email</span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<!-- adin.yahya6@gmail.com -->
<!-- this.$refs.otpInput.clearInput() -->
<script>
import mode from '@/mode.js'
export default {
  name: 'landing-aduan',
  data () {
    return {
      category: null,
      email: '',
      isOTPsend: false,
      isLoadingOtp: false,
      otpData: null,
      resendWaiting: 0,
      resendLoading: false,
      icons: [
        { icon: 'static/img/icon/Icon-1.png', capt: 'Perlindungan<br>Identitas' },
        { icon: 'static/img/icon/Icon-2.png', capt: 'Keterbukaan<br>Komunikasi' },
        { icon: 'static/img/icon/Icon-3.png', capt: 'Pencegahan<br>Retaliasi' }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    wbsURL () {
      return this.$_config.wbs[mode].replace('/api/', '/#/login')
    }
  },
  methods: {
    getAPI (method, api, param, obj = null) {
      return this.$_api[method](api, param)
        .then((res) => {
          return obj ? res.data[obj] || res.data : res.data
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    async getData () {
      this.category = await this.getAPI('fetch', 'get', this.$_config.wbs[mode] + 'no-auth/allegation-categories/dataset')
      this.isLoading = false
    },
    requestOTP (resend = false) {
      if (!resend) this.isLoadingOtp = true
      else this.resendLoading = true
      this.$_api
        .fetch('post', this.$_config.wbs[mode] + 'no-auth/create-allegations/request-otp', { email: this.email })
        .then((res) => {
          this.isOTPsend = true
          this.isLoadingOtp = false
          if (resend) {
            this.resendLoading = false
            this.resendWaiting = 60
            this.setWaiting()
          }
        })
        .catch((err) => {
          this.isLoadingOtp = false
          this.$_alert.error(err)
        })
    },
    otpComplete (e) {
      this.otpData = e
    },
    checkOTP (e) {
      this.$_api
        .fetch('post', this.$_config.wbs[mode] + 'no-auth/create-allegations/verification-otp', { email: this.email, otp: this.otpData })
        .then((res) => {
          // redirect
          this.$router.push({
            name: 'pengisian-aduan',
            query: { ...{ dts: new Date().getTime() }, ...{ email: this.email, otp: this.otpData } }
          })
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    setWaiting () {
      setTimeout(() => {
        if (this.resendWaiting > 0) {
          this.resendWaiting--
          this.$nextTick()
          this.setWaiting()
        }
      }, 1000)
    }
  }
}
</script>
<style lang="">
  .otp-input {
    font-size: 2rem;
    width: 50px;
    padding: 1rem 0.57rem;
    text-align: center;
    margin-right: 10px;
    border-radius: 8px;
    border: 1px solid #eeeeee;
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .otp-input:focus-visible {
    outline: #ddf2fa solid 0.5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/landing-page/aduan.vue